import { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';

class Form extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    const { children } = this.props;

    return <Fragment>{children}</Fragment>;
  }
}

export default reduxForm()(Form);
